var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5.175 7.004a3.003 3.003 0 0 1 2.83-2.001c1.305 0 2.416.835 2.83 2.001h1.985c-.896-.756-1.401-1.193-1.515-1.31a1.03 1.03 0 0 1-.292-.705c0-.538.453-.989.99-.989a.95.95 0 0 1 .696.294c.117.124 1.12 1.13 3.008 3.016.176.176.293.41.293.684a.976.976 0 0 1-.283.695l-3.013 3.027a.995.995 0 0 1-1.691-.702c0-.273.116-.544.292-.72l1.515-1.292h-1.98a3.003 3.003 0 0 1-2.835 2.016A3.003 3.003 0 0 1 5.17 9.002H3.18l1.515 1.292c.176.176.292.447.292.72a.995.995 0 0 1-1.69.702L.282 8.69A.976.976 0 0 1 0 7.994c0-.273.117-.508.293-.684A535.858 535.858 0 0 0 3.3 4.294.95.95 0 0 1 3.997 4c.537 0 .99.45.99.989 0 .273-.12.528-.292.705-.114.117-.62.554-1.515 1.31h1.995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowReview);
export default __webpack_public_path__ + "static/media/flow-review.715da8af6f180bc128a41d8be20c84f9.svg";
export { ForwardRef as ReactComponent };